module.exports = __webpack_public_path__ + "img/mc.1a5f2602.svg";